import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

export const Bill_Status = Object.freeze({
  SENT: 'sent',
  SETTLED: 'settled',
  PARTIALLY_PAID: 'partiallyPaid',
  NEW: 'new',
  ON_HOLD: 'onHold',
  VALIDATED: 'validated',
  OVERDUE: 'overdue',
});

export const getBillStatusName = status => {
  switch (status) {
    case Bill_Status.SENT:
      return ContentManager.translate('billing_card_tag_processing_payment');
    case Bill_Status.NEW:
      return ContentManager.translate('billing_card_tag_unpaid');
    case Bill_Status.PARTIALLY_PAID:
      return ContentManager.translate('billing_card_tag_partially_paid');
    case Bill_Status.SETTLED:
      return ContentManager.translate('billing_card_tag_paid');
    case Bill_Status.OVERDUE:
      return ContentManager.translate('billing_card_tag_overdue');
    case Bill_Status.ON_HOLD:
    case Bill_Status.VALIDATED:
      return 'Due';
  }
};
